import { render } from "./change-password-popup.vue?vue&type=template&id=482f6dee&scoped=true"
import script from "./change-password-popup.vue?vue&type=script&lang=js"
export * from "./change-password-popup.vue?vue&type=script&lang=js"

import "./change-password-popup.vue?vue&type=style&index=0&id=482f6dee&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482f6dee"]])

export default __exports__